import { v4 as uuidv4 } from "uuid";

import type { IQueueEvent } from "../store/types";

/**
 * Empty Event Metric Spawner
 *
 * Creates an empty event object for cases where no metrics are available
 * but the user wants to advance the game state (e.g., cameras missed a pitch).
 *
 * Returns a minimal IQueueEvent with:
 * - Generated UUIDs for event and pitch
 * - null for pitch_data and hit_data (no TrackMan metrics)
 * - Current server timestamp
 * - noMetricEvent flag to indicate manual/no-metrics event
 * - Placeholder values for required fields (caller should fill in gameState/focusedPlayers)
 */
export const emptyEventMetricSpawner = (): IQueueEvent => {
  const generatedUUID = uuidv4();
  const generatedPitchUUID = uuidv4();
  const currentTime = Math.floor(new Date().getTime() / 1000);

  return {
    event_uuid: generatedUUID,
    contributing_events: [generatedUUID],
    event_time: currentTime,
    serverTime: currentTime,
    ball: "unknown",
    pitch_data: null,
    hit_data: null,
    tagData: null,
    gameState: null,
    focusedPlayers: undefined,
    configured_strike_zone: null,
    noMetricEvent: true,
    pitchUUID: generatedPitchUUID,
  };
};
